<template>
    <v-dialog v-model="show" max-width="80vw">
        <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="submit"
            lazy-validation
        >
            <v-card>
                <v-card-title>
                    <span class="headline">New Item</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="9">
                                <v-text-field
                                    v-model="form.name"
                                    :rules="[v => !!v || 'Name is required']"
                                    label="Name"
                                    required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-autocomplete
                                    v-model="form.maintenance_expense_subcategory_id"
                                    :items="subcategories"
                                    item-text="name"
                                    item-value="id"
                                    label="Subcategory"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="form.description"
                                    label="Description"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-autocomplete
                                    v-model="form.unit_of_measure"
                                    :items="units"
                                    label="Unit of Measure"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="2">
                                <v-text-field
                                    v-model="form.revision"
                                    label="Revision"
                                    disabled
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="form.item_number"
                                    label="Item Number (SKU)"
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete
                                    v-model="form.manufacturer"
                                    :items="manufacturers"
                                    label="Manufacturer"
                                    outlined
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="show = false">
                        Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" type="submit" text>
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
export default {
    name: 'ItemDialog',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        subcategories: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            valid: false,
            form: {
                name: '',
                description: '',
                unit_of_measure: '',
                item_number: '',
                revision: 'A',
                manufacturer: '',
                maintenance_expense_subcategory_id: '',
            },
            units: [
                'Piece',
                'Feet',
                'Inches',
                'Meters',
                'Pounds',
                'Kilograms',
                'Gallons',
                'Liters',
                'Cubic Feet',
                'Cubic Meters'
            ],
            manufacturers: [
                '3M',
                'A.O. Smith',
                'Aavid Thermalloy',
                'ABB',
                'Able Seal & Design',
                'ACDelco',
                'Acme Electric',
                'Acopian',
                'Acro',
                'Adalet',
                'Adam Tech',
                'Adams Rite',
                'Adaptec',
                'ADC'
            ]
        };
    },
    computed: {
        show: {
            get() {
                return this.dialog;
            },
            set(val) {
                if (!val) {
                    this.$emit('update:dialog', val);
                }
            }
        }
    }
};
</script>
